import { Breadcrumb, CardContainer, Container } from "components";
import { useFormik } from "formik";
import * as Yup from "yup";
import React, { useContext, useState } from "react";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { API_URL_agent } from "constants/api";
import { agentReducers } from "redux/agentSlice";
import { putData } from "actions";
import { AuthContext } from "context/AuthContext";

const ChangePassword = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { datauser } = useContext(AuthContext);
  const [visiblePassword, setVisiblePassword] = useState(false);
  const [visibleOldPassword, setVisibleOldPassword] = useState(false);
  const [visibleConfirmPassword, setVisibleConfirmPassword] = useState(false);

  const formik = useFormik({
    initialValues: {
      old_password: "",
      password: "",
      confirm_password: "",
    },
    validationSchema: Yup.object({
      old_password: Yup.string().required("Old Password is required"),
      password: Yup.string()
        .min(8, "Password must be at least 8 characters long")
        .required("Password is required"),
      confirm_password: Yup.string()
        .oneOf([Yup.ref("password"), null], "Passwords must match")
        .min(8, "Password must be at least 8 characters long")
        .required("Confirm Password is required"),
    }),
    onSubmit: (values) => {
      const formData = new FormData();
      formData.append("old_password", values.old_password);
      formData.append("password", values.password);
      putData(
        `${API_URL_agent}${datauser.id}/`,
        formData,
        { dispatch, redux: agentReducers },
        "ADD_AGENT",
        () => {
          navigate("/dashboard/profile/informationprofile");
        }
      );
    },
  });

  return (
    <Container>
      <Breadcrumb title={"Form Password"} excludedPaths={["profile"]} />
      <CardContainer title={"Change Password"}>
        <form onSubmit={formik.handleSubmit}>
          <div className="m-5">
            <div className=" grid grid-cols-12 items-center mb-4 justify-start">
              <label className="col-span-12 lg:col-span-2 font-bold">
                Old Password <span className="text-red-500 "> *</span>:
              </label>
              <div className="relative col-span-12 lg:col-span-4">
                <input
                  type={visibleOldPassword ? "text" : "password"}
                  id="old_password"
                  name="old_password"
                  value={formik.values.old_password}
                  onChange={formik.handleChange}
                  className="p-1 w-full border border-gray-300 dark:text-black focus:border-blue-300 rounded-sm focus:outline-none focus:ring-2 focus:ring-blue-300"
                />
                {formik.touched.old_password && formik.errors.old_password && (
                  <div className="text-red-500 block text-xs">
                    {formik.errors.old_password}
                  </div>
                )}
                <div
                  className="absolute text-gray-400 right-2 top-1.5 text-2xl cursor-pointer"
                  onClick={() => setVisibleOldPassword(!visibleOldPassword)}
                >
                  {visibleOldPassword ? <FaEye /> : <FaEyeSlash />}
                </div>
              </div>
            </div>
            <div className="grid grid-cols-12 items-center mb-4">
              <label className="col-span-12 lg:col-span-2 font-bold">
                New Password <span className="text-red-500 "> *</span>:
              </label>
              <div className="relative col-span-12 lg:col-span-4">
                <input
                  type={visiblePassword ? "text" : "password"}
                  id="password"
                  name="password"
                  value={formik.values.password}
                  onChange={formik.handleChange}
                  className="p-1 w-full border border-gray-300 dark:text-black focus:border-blue-300 rounded-sm focus:outline-none focus:ring-2 focus:ring-blue-300"
                />
                {formik.touched.password && formik.errors.password && (
                  <div className="text-red-500 block text-xs">
                    {formik.errors.password}
                  </div>
                )}
                <div
                  className="absolute text-gray-400 right-2 top-1.5 text-2xl cursor-pointer"
                  onClick={() => setVisiblePassword(!visiblePassword)}
                >
                  {visiblePassword ? <FaEye /> : <FaEyeSlash />}
                </div>
              </div>
            </div>
            <div className="grid grid-cols-12 items-center mb-4">
              <label className="col-span-12 lg:col-span-2 font-bold">
                Confirm Password <span className="text-red-500 "> *</span>:
              </label>
              <div className="relative col-span-12 lg:col-span-4">
                <input
                  type={visibleConfirmPassword ? "text" : "password"}
                  id="confirm_password"
                  name="confirm_password"
                  value={formik.values.confirm_password}
                  onChange={formik.handleChange}
                  className="p-1 w-full col-span-12 lg:col-span-10 border border-gray-300 dark:text-black focus:border-blue-300 rounded-sm focus:outline-none focus:ring-2 focus:ring-blue-300"
                />
                {formik.touched.confirm_password &&
                  formik.errors.confirm_password && (
                    <div className="text-red-500 block text-xs">
                      {formik.errors.confirm_password}
                    </div>
                  )}
                <div
                  className="absolute text-gray-400 right-2 top-1.5 text-2xl cursor-pointer"
                  onClick={() =>
                    setVisibleConfirmPassword(!visibleConfirmPassword)
                  }
                >
                  {visibleConfirmPassword ? <FaEye /> : <FaEyeSlash />}
                </div>
              </div>
            </div>
          </div>
          <div className="h-14 w-full flex items-center px-5 bg-neutral-100 dark:bg-neutral-700 border-b border-neutral-200 dark:border-neutral-600">
            <button
              type="submit"
              className="rounded-md text-white py-1.5 w-36 bg-red-500 hover:bg-red-700 "
            >
              Change Password
            </button>
          </div>
        </form>
      </CardContainer>
    </Container>
  );
};

export default ChangePassword;
